import { Box, Flex, Progress, Stack, useToast } from '@chakra-ui/react';
import useUpload from 'hooks/useUpload';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { COLOR_SCHEMA } from '../../helpers/constant';

export const FILE_EXTENSION_UPLOAD_ALLOWED = [
  '.pdf',
  '.doc',
  '.docx',
  '.xlsx',
  '.xls',
  '.csv',
  '.ppt',
  '.pptx',
  '.tsv',
  '.md',
  '.txt',
];

const UploadInput = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const { uploadFiles, isUploading, progressValue } = useUpload();

  const { stats } = useSelector((state) => state.upload);

  const onDrop = useCallback((acceptedFiles: File[] = []) => {
    if (acceptedFiles?.length > 0) {
      uploadFiles(acceptedFiles);
    } else {
      toast({
        title: 'No valid files founded',
        status: 'error',
        position: 'bottom-right',
        isClosable: true,
      });
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'application/msword': FILE_EXTENSION_UPLOAD_ALLOWED,
    },
    validator: blockSpecialFile,
  });

  function blockSpecialFile(file: File) {
    if (file.name?.includes('.dot')) {
      return {
        code: 'file-not-support',
        message: `Not support this type file!`,
      };
    }
    return null;
  }

  return (
    <Box
      color='color_amatrium_text'
      bg='bg_box'
      border='border_gray_solid'
      borderRadius='24px'
      cursor={!isUploading ? 'pointer' : ''}
      {...(!isUploading &&
        getRootProps({
          onClick: (e) => console.log(e),
        }))}
    >
      <Flex align='center' justify='center' minH='240' textAlign='center'>
        <Box h='100%' fontSize={24}>
          <div>
            <input {...getInputProps()} type='file' id='filepicker' name='fileList' multiple />
            {isUploading ? (
              <>
                <Box mb={5}>
                  {t('upload.uploadingProgress', {
                    success: stats.uploadSuccess,
                    total: stats.total,
                  })}
                </Box>
                <Box minW={400}>
                  <Progress hasStripe value={progressValue} />
                </Box>
              </>
            ) : (
              <Stack direction='row'>
                <Box>{t('upload.dropHere')}</Box>
                <Box color={COLOR_SCHEMA.PURPIL} fontWeight={600}>
                  {t('upload.browse')}
                </Box>
              </Stack>
            )}
          </div>
        </Box>
      </Flex>
    </Box>
  );
};

export default UploadInput;
